import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileName'
})
export class FileNamePipe implements PipeTransform {
  fileName:string;
  transform(value: any, args?: any): any {
    if (value) {
      
      this.fileName = value.substr(value.lastIndexOf('/')+1,value.length-value.lastIndexOf('/'));
      return this.fileName;
  } else {
      return 'No Date';
  }
  }

}
